import abstractModel from "../../core/MercatelyModel";

const resource = '/api/v1/teams';

const model = abstractModel(resource);

export default model;
